import { LoadingButton } from '@mui/lab'
import styles from './Button.module.scss'

import cx from 'classnames'

const Button = props => {
  const {
    isLoading = false,
    disabled = false,
    onClick,
    label,
    type,
    className,
    submit = false
  } = props

  let style
  switch (type) {
    case 'delete':
      style = styles.removeButton
      break
    case 'light-delete':
      style = styles.removeButtonLight
      break
    case 'next':
      style = styles.nextButton
      break
    case 'add':
      style = styles.addButton
      break
    case 'cancel':
      style = styles.cancelButton
      break
    case 'info':
      style = styles.infoButton
      break
    default:
      break
  }
  return (
    <div className={styles.buttonWrapper}>
      <LoadingButton
        type={submit ? 'submit' : 'button'}
        fullWidth
        loadingPosition='end'
        variant='contained'
        className={cx(style, className)}
        loading={isLoading}
        disabled={disabled}
        onClick={onClick}
      >
        {label}
      </LoadingButton>
    </div>
  )
}
export default Button
